import { messageAlert } from '@/event/alert/messageAlert'
import { ref } from 'vue'

export const messageAddAddressEmpty = { message: '', class: '', errors: [], address: 0 }

export const messageAddAddress = ref(messageAddAddressEmpty)
